
    import { defineComponent, SetupContext } from 'vue'
    import Icon from '@/components/Icon/IndexIcon.vue'

    interface SetupReturn {
        emit: SetupContext['emit'];

        handleModal (type: string): void;
    }

    export default defineComponent({
        emits: ['on-update'],

        components: { Icon },

        setup (props, { emit }: SetupContext): SetupReturn {
            function handleModal (type: string): void {
                emit('on-update', type)
            }

            return {
                emit,
                handleModal
            }
        }
    })
